import { render, staticRenderFns } from "./PointsForm.vue?vue&type=template&id=37ec2ced&scoped=true&"
import script from "./PointsForm.vue?vue&type=script&lang=js&"
export * from "./PointsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ec2ced",
  null
  
)

export default component.exports